document.addEventListener("DOMContentLoaded", function nbcMap() {
  if (!window.nbc?.locations) return;

  const L = window.L;

  const radio = document.createElement("div");
  document.body.appendChild(radio);

  (function setupSidebar() {
    const sidebar = document.querySelector(".nbc-sidebar");

    let timeoutIn, timeoutOut;
    sidebar.addEventListener("mouseover", () => {
      clearTimeout(timeoutOut);

      if (sidebar.classList.contains("focus")) {
        return;
      }

      sidebar.classList.add("focus");

      clearTimeout(timeoutIn);
      timeoutIn = setTimeout(() => sidebar.classList.add("expanded"), 400);
    });

    sidebar.addEventListener("mouseout", () => {
      clearTimeout(timeoutIn);

      if (!sidebar.classList.contains("focus")) {
        return;
      }

      sidebar.classList.remove("focus");

      clearTimeout(timeoutOut);
      timeoutOut = setTimeout(() => sidebar.classList.remove("expanded"), 50);
    });

    const controls = document.querySelectorAll(".nbc-button");
    controls.forEach((btn) => {
      btn.addEventListener("click", onMapFilter);
    });

    let fromRoute;
    function onMapFilter(ev) {
      const btn = ev.currentTarget;

      let route = btn.name;
      if (fromRoute === route) {
        route = null;
      }

      const targetEvent = new CustomEvent("nbc:target", {
        detail: { target: null },
      });

      radio.dispatchEvent(targetEvent);

      const filterEvent = new CustomEvent("nbc:filter", {
        detail: { route },
      });

      radio.dispatchEvent(filterEvent);
    }

    const mockBtn = () => {
      let btn = controls[0].cloneNode();
      btn.name = fromRoute;
      btn.classList.add("active");
      return btn;
    };

    sidebar.children[1].addEventListener("click", () =>
      onMapFilter({ currentTarget: mockBtn() })
    );

    radio.addEventListener("nbc:filter", (ev) => {
      const { route } = ev.detail;

      controls.forEach((btn) => {
        if (btn.name === route) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      });

      fromRoute = route;
    });
  })();

  (function setupMap() {
    const { routes, locations } = window.nbc;

    const icons = {
      ring: {},
      circle: {},
    };

    routes.forEach((route) => {
      icons.ring[route.slug] = L.icon({
        iconUrl: `/wp-content/themes/wpct-nbc/assets/images/marker-ring-${route.index}.png`,
        iconSize: [20, 20],
      });
    });

    routes.forEach((route) => {
      icons.circle[route.slug] = L.icon({
        iconUrl: `/wp-content/themes/wpct-nbc/assets/images/marker-circle-${route.index}.png`,
        iconSize: [20, 20],
      });
    });

    const ringMarkers = locations
      .filter((location) => {
        return (
          !isNaN(location.lat) &&
          !isNaN(location.lng) &&
          location.lat &&
          location.lng
        );
      })
      .map((location) => {
        const icon = icons.ring[location.route];
        const marker = L.marker([location.lng, location.lat], { icon })
          .on("mouseover", (ev) => onMarkerFocus(ev, location))
          .on("mouseout", onMarkerUnfocus)
          .on("click", (ev) => onMarkerClick(ev, location));

        Object.defineProperty(marker, "location", {
          get: () => ({ ...location }),
        });

        return marker;
      });

    const circleMarkers = locations
      .filter((location) => {
        return (
          !isNaN(location.lat) &&
          !isNaN(location.lng) &&
          location.lat &&
          location.lng
        );
      })
      .map((location) => {
        const icon = icons.circle[location.route];
        const marker = L.marker([location.lng, location.lat], { icon })
          .on("mouseover", (ev) => onMarkerFocus(ev, location))
          .on("mouseout", onMarkerUnfocus)
          .on("click", (ev) => onMarkerClick(ev, location));

        Object.defineProperty(marker, "location", {
          get: () => ({ ...location }),
        });

        return marker;
      });

    let visibleLocations = ringMarkers;
    let locationLayers = L.featureGroup(visibleLocations);

    const popup = L.popup({ offset: L.point(0, -30), keepInView: true });
    function onMarkerFocus(ev, { name, address }) {
      popup
        .setLatLng(ev.target.getLatLng())
        .setContent(`<strong>${name}</strong><br>${address}`)
        .openOn(map);
    }

    let fromTarget;
    function onMarkerClick(_, { activity: target }) {
      if (fromTarget === target) {
        target = null;
      }

      const event = new CustomEvent("nbc:target", {
        detail: { target },
      });

      radio.dispatchEvent(event);
    }

    function onMarkerUnfocus() {
      if (popup.isOpen()) popup.close();
    }

    var map = L.map("nbcMap", {
      zoom: 15,
      center: [41.4465, 2.1726],
      gestureHandling: true,
      gestureHandlingOptions: {
        text: {
          touch: "Hey bro, use two fingers to move the map",
          scroll: "Hey bro, use ctrl + scroll to zoom the map",
          scrollMac: "Hey bro, use \u2318 + scroll to zoom the map",
        },
      },
    });

    const apiKey = "cCdrEhHvDeZPDqILMoU3";
    L.tileLayer(
      `https://api.maptiler.com/maps/dataviz-v4/{z}/{x}/{y}.png?key=${apiKey}`,
      {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        attribution:
          '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a><a href="https://www.openstreetmap.org/copyright" target="_blank"> &copy; OpenStreetMap</a>',
        crossOrigin: true,
      }
    ).addTo(map);

    ringMarkers.forEach((marker) => marker.addTo(map));
    map.fitBounds(locationLayers.getBounds(), { padding: [50, 50] });

    radio.addEventListener("nbc:filter", function (ev) {
      const { route } = ev.detail;

      visibleLocations = [];
      ringMarkers.forEach((marker) => {
        map.removeLayer(marker);

        if (!route || marker.location.route === route) {
          map.addLayer(marker);
          visibleLocations.push(marker);
        }
      });

      locationLayers = L.featureGroup(visibleLocations);
      setTimeout(
        () =>
          map.fitBounds(locationLayers.getBounds(), {
            animate: true,
            duration: 0.5,
            padding: [50, 50],
          }),
        100
      );
    });

    radio.addEventListener("nbc:target", function (ev) {
      const { target } = ev.detail;

      ringMarkers.forEach((marker) => {
        if (target && marker.location.activity === target) {
          map.removeLayer(marker);
        } else if (marker.location.activity === fromTarget) {
          map.addLayer(marker);
        }
      });

      circleMarkers.forEach((marker) => {
        if (target && marker.location.activity === target) {
          map.addLayer(marker);
          setTimeout(() => map.flyTo(marker.getLatLng(), 15), 0);
        } else if (marker.location.activity === fromTarget) {
          map.removeLayer(marker);
        }
      });

      if (!target) {
        setTimeout(
          () =>
            map.fitBounds(locationLayers.getBounds(), {
              animate: true,
              duration: 0.5,
              padding: [50, 50],
            }),
          0
        );
      }

      fromTarget = target;
    });
  })();

  (function setupArchive() {
    let fromTarget;

    const onEntryClick = (entry) => {
      let { activity: target } = entry.location;

      if (target === fromTarget) {
        target = null;
      }

      const event = new CustomEvent("nbc:target", {
        detail: { target },
      });

      radio.dispatchEvent(event);
    };

    const resetFilter = () => {
      const targetEvent = new CustomEvent("nbc:target", {
        detail: { target: null },
      });

      radio.dispatchEvent(targetEvent);

      const filterEvent = new CustomEvent("nbc:filter", {
        detail: { route: null },
      });

      radio.dispatchEvent(filterEvent);
    };

    const entries = document.querySelectorAll(".wp-block-post.activity");
    entries.forEach((entry) => {
      const locationEl = entry.children[0];

      let entryRoute = "itinerari-1";
      const classes = Array.from(entry.classList);
      for (let i = 0; i < classes.length; i++) {
        if (/^route-/.test(classes[i])) {
          entryRoute = classes[i].replace("route-", "");
          break;
        }
      }

      Object.defineProperty(entry, "route", {
        get: () => entryRoute,
      });

      let entryLocation = { links: {} };
      for (let i = 0; i < window.nbc.locations.length; i++) {
        const loc = window.nbc.locations[i];
        if (loc.activity === locationEl.dataset.activity) {
          entryLocation = loc;
          break;
        }
      }

      Object.defineProperty(entry, "location", {
        get: () => entryLocation,
      });

      Object.defineProperty(entry, "activity", {
        get: () => ({
          slug: entryLocation.activity,
          title: locationEl.querySelector(".wp-block-post-title").textContent,
          excerpt: locationEl.querySelector(".wp-block-post-excerpt")
            .textContent,
        }),
      });

      entry
        .querySelector(".nbc-activity-circle")
        .addEventListener("click", () => onEntryClick(entry));

      entry
        .querySelector(".wp-block-post-title")
        .addEventListener("click", () => onEntryClick(entry));
    });

    const prompt = document.querySelector(".nbc-prompt");
    prompt.__html = prompt.innerHTML;

    radio.addEventListener("nbc:filter", function (ev) {
      const { route } = ev.detail;

      entries.forEach((entry) => {
        if (route && entry.route !== route) {
          entry.classList.add("hidden");
          entry.setAttribute("aria-hidden", "true");
        } else {
          entry.classList.remove("hidden");
          entry.removeAttribute("aria-hidden");
        }
      });

      if (route) {
        const routeData = window.nbc.routes.find(({ slug }) => route === slug);
        prompt.innerHTML = `
          <h2 class="wp-block-heading has-contrast-color has-text-color has-link-color has-primary-font-family wp-elements-2">
            <strong style="color:${routeData.color}">${routeData.name}</strong> <button>❌</button>
          </h2>
          <p class="wp-block-paragraph">${routeData.description}</p>
        `;
        prompt
          .querySelector("h2 button")
          .addEventListener("click", () => resetFilter());
      } else {
        prompt.innerHTML = prompt.__html;
      }

      if (window.innerWidth <= 920) {
        document
          .getElementById("nbcMap")
          .scrollIntoView({ block: "center", behavior: "smooth" });
      } else {
        prompt.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    });

    radio.addEventListener("nbc:target", function (ev) {
      const { target } = ev.detail;

      entries.forEach((entry) => {
        if (entry.location.activity === target) {
          entry.classList.add("target");
          setTimeout(
            () => entry.scrollIntoView({ block: "center", behavior: "smooth" }),
            0
          );
        } else {
          entry.classList.remove("target");
        }
      });

      fromTarget = target;
    });
  })();

  (function setupStickyMap() {
    const nbc = document.querySelector(".nbc");

    let el = nbc;
    let offsetTop = nbc.offsetTop;
    while (el.offsetParent) {
      el = el.offsetParent;
      offsetTop += el.offsetTop;
    }

    const onScroll = () => {
      const scrollTop = window.innerHeight - window.scrollY;
      const overflow = window.innerWidth >= 920 ? 100 : 0;

      if (scrollTop + overflow <= offsetTop) {
        if (!nbc.classList.contains("sticky")) {
          nbc.classList.add("sticky");
        }
      } else {
        if (nbc.classList.contains("sticky")) {
          nbc.classList.remove("sticky");
        }
      }
    };

    document.addEventListener("scroll", onScroll);
    onScroll();
  })();
});

document.addEventListener("DOMContentLoaded", () => {
  const inputs = document.getElementsByName("activitats[]");

  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    const label = input.nextElementSibling;
    const [name, dates, address] = label.textContent.split("|");
    label.innerHTML = `<strong>${name}</strong><br><span>${dates}</span><br><span>${address}</span>`;
  }
});
